import { triggerToast } from "@qivia/ui";
import { useTranslation } from "react-i18next";
import { PublicTransactionsPropsType } from "../transactionsAPI";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import {
  authorizationsListAsync,
  transactionsListAsync,
  selectCreateMerchantCodeStatus,
  getLastReminderDateAsync,
  sendSmsAsync,
  sendSmsReplaceInvalidAsync,
  getSupportingDocument,
  selectTransactionsListStatus,
  selectAuthorizationsListStatus,
} from "../transactionsSlice";
import { useCallback, useEffect } from "react";
import { TransactionsSidePanel } from "../sidePanel/SidePanel";
import { useNavigate, useParams } from "react-router-dom";
import { selectCompany } from "../../homeSlice";
import { SharedInterfaceCardTransactions } from "./sharedInterface";

export const CardTransactionsTab = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const company = useAppSelector(selectCompany);

  const createMerchantCodeStatus = useAppSelector(
    selectCreateMerchantCodeStatus,
  );
  const transactionsListStatus = useAppSelector(selectTransactionsListStatus);
  const authorizationsListStatus = useAppSelector(
    selectAuthorizationsListStatus,
  );

  useEffect(() => {
    if (company && transactionsListStatus === "idle") {
      void dispatch(transactionsListAsync({ companyUuid: company.uuid }));
    }
  }, [dispatch, company, createMerchantCodeStatus, transactionsListStatus]);

  useEffect(() => {
    if (company && authorizationsListStatus === "idle") {
      void dispatch(authorizationsListAsync(company.uuid));
    }
  }, [dispatch, company, createMerchantCodeStatus, authorizationsListStatus]);

  useEffect(() => {
    if (createMerchantCodeStatus === "success") {
      triggerToast(t(`transactions.createMerchantCode.success`) || "", "valid");
    } else if (createMerchantCodeStatus === "failed") {
      triggerToast(t("transactions.createMerchantCode.failure") || "", "error");
    }
  }, [createMerchantCodeStatus, t]);

  const sidePanelAction = useCallback(
    (props: Partial<PublicTransactionsPropsType>) => {
      navigate(`/home/transactions/cards/${props.uuid}`);
    },
    [navigate],
  );

  const getLastReminderDateAction = useCallback(
    (transactionUuid: string) => {
      void dispatch(getLastReminderDateAsync({ transaction: transactionUuid }));
    },
    [dispatch],
  );

  const sendSmsAction = useCallback(
    (props: {
      driverPhone: string;
      driverName: string;
      transactionUuid: string;
    }) => {
      void dispatch(sendSmsAsync(props));
    },
    [dispatch],
  );

  const sendSmsReplaceInvalidAction = useCallback(
    (props: {
      driverPhone: string;
      driverName: string;
      transactionUuid: string;
    }) => {
      void dispatch(sendSmsReplaceInvalidAsync(props));
    },
    [dispatch],
  );

  const getSupportingDocumentAction = useCallback(
    (supportingDocumentUuid: string) => {
      void dispatch(getSupportingDocument(supportingDocumentUuid));
    },
    [dispatch],
  );

  if (params.tab !== "cards") {
    return;
  }

  return (
    <SharedInterfaceCardTransactions
      sidePanelAction={sidePanelAction}
      sidePanel={
        <TransactionsSidePanel
          canRedirectToRule
          canCorrectMerchantCategory
          sendSmsReplaceInvalidAction={sendSmsReplaceInvalidAction}
          getSupportingDocumentAction={getSupportingDocumentAction}
          getLastReminderDateAction={getLastReminderDateAction}
          sendSmsAction={sendSmsAction}
        />
      }
    />
  );
};
